import type {ReactElement} from 'react';
import React from 'react';
import {getRecommendedFont} from '@Libraries/font-library';
import {BaseLanguageNotSupportedOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-language-not-supported-option';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';

export function LanguageNotSupportedByTranscriptFontOption(): ReactElement<any> | null {
  const activeTranscriptItem = useGetSelectedTranscriptItem();
  const fontFamily = useGetKeyFromSubtitleTextStylesForTranscriptItem('fontFamily');
  const fontScript = useGetKeyFromSubtitleTextStylesForTranscriptItem('script');

  if (!activeTranscriptItem || fontFamily === undefined || fontScript === undefined) {
    return null;
  }

  const onClickUseRecommendedFont = (): void => {
    const recommendedFont = getRecommendedFont(fontScript);

    void activeTranscriptItem.updateAllSubtitlesStylesFromSubtitleObject({
      sentenceTextStyles: {
        fontFamily: recommendedFont,
      },
      activeWordTextStyles: {
        fontFamily: recommendedFont,
      },
    });
  };

  return <BaseLanguageNotSupportedOption selectedFontFamily={fontFamily} onClickUseRecommendedFont={onClickUseRecommendedFont} script={fontScript} />;
}
